import { render, staticRenderFns } from "./MapSizes.vue?vue&type=template&id=830eb7f4&lang=html&"
import script from "./MapSizes.vue?vue&type=script&lang=js&"
export * from "./MapSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports